import { COS_PATH } from './base'
import axios from 'axios'
import request from '@/utils/request'

export const getComplaintJSON = () => axios.get(`${COS_PATH}/complaint.json`).then((resp) => resp.data)

// 查询投诉列表
export function getComplaintList(data) {
  return request({
    url: '/user/admin/complaints/list',
    method: 'POST',
    data,
  })
}

// 投诉处理
export function complaintHandle(data) {
  return request({
    url: '/user/admin/complaints/handle',
    method: 'POST',
    data,
  })
}
